import { render, staticRenderFns } from "./VuePopper.vue?vue&type=template&id=be84a4a4&"
import script from "./VuePopper.vue?vue&type=script&lang=js&"
export * from "./VuePopper.vue?vue&type=script&lang=js&"
import style0 from "./VuePopper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports